module.exports = __webpack_public_path__ + "images/cb0de4e97aaf1507ff39f921eeb88e24.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/marina_thumb.jpg
// module id = 156
// module chunks = 24